var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2345 2.63441C8.38452 2.48443 8.58797 2.40018 8.8001 2.40018C9.01223 2.40018 9.21567 2.48443 9.3657 2.63441L14.1657 7.43441C14.3157 7.58443 14.3999 7.78787 14.3999 8.00001C14.3999 8.21214 14.3157 8.41558 14.1657 8.56561L9.3657 13.3656C9.21482 13.5113 9.01273 13.592 8.80298 13.5901C8.59322 13.5883 8.39257 13.5042 8.24424 13.3559C8.09592 13.2075 8.01178 13.0069 8.00996 12.7971C8.00814 12.5874 8.08877 12.3853 8.2345 12.2344L11.6689 8.80001H2.4001C2.18792 8.80001 1.98444 8.71572 1.83441 8.56569C1.68438 8.41566 1.6001 8.21218 1.6001 8.00001C1.6001 7.78783 1.68438 7.58435 1.83441 7.43432C1.98444 7.28429 2.18792 7.20001 2.4001 7.20001H11.6689L8.2345 3.76561C8.08452 3.61558 8.00027 3.41214 8.00027 3.20001C8.00027 2.98787 8.08452 2.78443 8.2345 2.63441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.ac552d6031df342eaa08295199a65a97.svg";
export { ForwardRef as ReactComponent };